import * as React from 'react';

import AccountPageDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/AccountPageDesktopMainNav';
import AccountPageMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/AccountPageMobileMainNav';
import DefaultConsumerPageHeaderProvider from 'bundles/composable-page-header-consumer/providers/DefaultConsumerPageHeaderProvider';
import LegacyGDPRBannerWrapper from 'bundles/composable-page-header/banners/LegacyGDPRBannerWrapper';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import DefaultMetaNavigation from 'bundles/composable-page-header/components/meta-nav/DefaultMetaNavigation';
import { DEFAULT_META_NAV_HEIGHT } from 'bundles/composable-page-header/constants';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

type Props = {
  /** If true, hides the meta navigation entirely and adjusts scroll offset */
  hideMetaNav?: boolean;
  /** If true, conditionally shows the GDPR banner. */
  showGDPRBanner?: boolean;
};

const AccountPageHeader = ({ hideMetaNav = false, showGDPRBanner = false }: Props) => {
  const metaNavComponent = hideMetaNav ? null : <DefaultMetaNavigation />;
  const banners = showGDPRBanner ? [{ name: 'GDPRBanner', component: <LegacyGDPRBannerWrapper /> }] : [];

  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<AccountPageDesktopMainNav />}
      mobileMainNav={<AccountPageMobileMainNav />}
      metaNav={metaNavComponent}
      scrollMovementOffset={{
        desktop: hideMetaNav ? 0 : DEFAULT_META_NAV_HEIGHT,
        mobile: 0,
      }}
      banners={banners}
    />
  );
};

const AccountPageHeaderWithProvider = ({ hideMetaNav = false, showGDPRBanner = false }: Props) => {
  return (
    <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={hideMetaNav ? 0 : DEFAULT_META_NAV_HEIGHT}>
      <DefaultConsumerPageHeaderProvider>
        <AccountPageHeader hideMetaNav={hideMetaNav} showGDPRBanner={showGDPRBanner} />
      </DefaultConsumerPageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
};

export default AccountPageHeaderWithProvider;
